var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("subscription-status-badge " + (_vm.getBadgeStatus.color))},[_c('span',{class:("badge__dot " + (_vm.isLastOrder && !_vm.isLastOrderInTerminalStatus ? 'animated' : ''))}),_vm._v("\n  "+_vm._s(_vm.getBadgeStatus.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }